import type { ExistingRoomI18nEditQuery, LangCode } from "@/lib/gql/__generated__/graphql";

import { useTransitionBlock } from "@/hooks/use-transition-block";

import { NameOfResourceBeingEdited } from "@/components/features/_components";
import type { FeatureIslandHeaderLangNavigatorProps } from "@/components/features/_layouts";
import {
	FeatureIslandContainer,
	FeatureIslandHeader,
	FeatureIslandMainWithCategory,
} from "@/components/features/_layouts";

import { ProductExistingRoomI18nFormModelContextProvider } from "./context";
import { useInitialized } from "../../model/usecase/existing/use-init";
import { RoomFormMain } from "../_components/root";
import { standardRoomI18nCategoriesAndManagerStore } from "../_store/categories";
import { HeaderUpdateButton } from "./components/header/update-button/update-button";

type Props = {
	activeLangCode: LangCode;
	navigator: FeatureIslandHeaderLangNavigatorProps;
	serverModel: ExistingRoomI18nEditQuery;
};

export const RoomI18nEditPresenter = ({ activeLangCode, navigator, serverModel }: Props) => {
	const init = useInitialized({ serverModel });

	const { categoryManagerStore } = standardRoomI18nCategoriesAndManagerStore;

	const { isDirty } = init.viewModel;
	useTransitionBlock(isDirty);

	const roomName = init.viewModel.name.value;

	return (
		<ProductExistingRoomI18nFormModelContextProvider value={{ ...init }}>
			<FeatureIslandContainer>
				<FeatureIslandHeader
					title="部屋の編集"
					activeLangCode={activeLangCode}
					navigator={navigator}
					rightChildren={<HeaderUpdateButton />}
				/>
				<FeatureIslandMainWithCategory categoryManagerStore={categoryManagerStore}>
					{/* @todo Layout の共通化が出来るまでは共通化しない */}
					<NameOfResourceBeingEdited resourceName={roomName} />

					<RoomFormMain roomCategoriesAndManagerStore={standardRoomI18nCategoriesAndManagerStore} />
				</FeatureIslandMainWithCategory>
			</FeatureIslandContainer>
		</ProductExistingRoomI18nFormModelContextProvider>
	);
};

RoomI18nEditPresenter.displayName = "RoomI18nEditPresenter";
